import { defineCustomElement } from 'vue';
import UserLoginWhiteMenu from './components/UserLoginWhiteMenu.ce.vue';

const customElement = defineCustomElement(UserLoginWhiteMenu);
customElements.define('user-login-white-menu', customElement);